import { Modal, Spin, Tabs } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import CommentForm from "../../Forms/CommentForm"

export const CommentModal = ({
  modalType,
  setModalType,
  modalTabKey,
  setModalTabKey,
  handleSaveForm,
  onCommentDelete,
  onDeleteAttachment,
  formRef,
  onClose,
  userInfoComment,
  userCommentData,
  userBusinessAccountsList,
  setCurrentBA, //used for users page comment modal
  commentDataLoading = false // true while the active tab's own comment is (re)loading
}) => {
  const isBaCommetsModal = modalType?.type === "comments_ba_page" //modal open from BA Page

  const { t } = useTranslation()
  const { saveFetching } = useSelector((state) => state.users)
  const { userInfo } = useSelector((state) => state.auth)

  const handleCloseModal = () => {
    setModalType(false)
    onClose()
  }

  return (
    <Modal
      open={true}
      centered={true}
      width={442}
      title={t("Comments")}
      footer={null}
      closable="true"
      onCancel={handleCloseModal}
      destroyOnClose
      classNames={{ content: "clear-bg" }}
      getContainer={() => document.getElementById("global-wrap")}
    >
      <Spin size="large" spinning={saveFetching || commentDataLoading || false}>
        <Tabs
          activeKey={modalTabKey}
          onChange={(key) => setModalTabKey(key)}
          destroyInactiveTabPane
          items={[
            {
              key: isBaCommetsModal ? "business_account" : "user_comment",
              label: isBaCommetsModal ? "Business account" : "User Comment",
              children: (
                <CommentForm
                  onSubmit={handleSaveForm}
                  onClose={handleCloseModal}
                  onCommentDelete={onCommentDelete}
                  onDeleteAttachment={onDeleteAttachment}
                  formRef={formRef}
                  isBaCommetsModal={isBaCommetsModal}
                  tabKeyType={isBaCommetsModal ? "comment_ba" : "comment_user"}
                  userInfoComment={userInfoComment}
                  userCommentData={userCommentData}
                  isDisabledSubmitBtn={commentDataLoading}
                />
              )
            },
            {
              key: isBaCommetsModal ? "business_accounts_owner" : "user_business_accounts",
              label: isBaCommetsModal ? "Business account's owner" : "User business accounts",
              children: (
                <CommentForm
                  onSubmit={handleSaveForm}
                  onClose={handleCloseModal}
                  onCommentDelete={onCommentDelete}
                  onDeleteAttachment={onDeleteAttachment}
                  formRef={formRef}
                  tabKeyType={
                    isBaCommetsModal ? "business_accounts_owner" : "user_business_accounts"
                  } //'business_accounts' on usersPage and "Business account's owner" on BA Page
                  isBaCommetsModal={isBaCommetsModal}
                  userBusinessAccountsList={userBusinessAccountsList}
                  setCurrentBA={setCurrentBA}
                  userInfoComment={userInfoComment}
                  userCommentData={userCommentData}
                  isDisabledSubmitBtn={commentDataLoading}
                />
              ),
              disabled: !userBusinessAccountsList?.length && !isBaCommetsModal
            }
          ]}
        />
      </Spin>
    </Modal>
  )
}
